import { render, staticRenderFns } from "./ComfirmOtp.vue?vue&type=template&id=60db4d56&scoped=true"
import script from "./ComfirmOtp.vue?vue&type=script&lang=js"
export * from "./ComfirmOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db4d56",
  null
  
)

export default component.exports